import React from 'react';
import { Link } from 'react-router-dom';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import './Banner.css';

export const Banner = ({ image, className, bannerLink }) => {
  const trackBannerClick = () => {
    trackEvent(TRACKING_ENUMS.EVENT_BUTTON_LINK_SELECTED, {
      page_button_text: 'Renew Now',
      page_name: 'account upgrade option offer',
      page_type: 'account',
    });
  };
  return (
    <div className="imageContainer">
      <Link className="desktopImage" to={bannerLink} onClick={trackBannerClick}>
        <img src={image.desktop} className={className}></img>
      </Link>
      <Link className="mobileImage" to={bannerLink} onClick={trackBannerClick}>
        <img src={image.mobile} className={className}></img>
      </Link>
    </div>
  );
};
